import { StoreOpenTimeAttrDayMapping } from "@/data/constants/clickAndCollect";
import { StoreDetails, StoreFeature } from "@/data/types/Store";
import { findStoreAttributeValueByName } from "@/data/utils/StoreStock";
import { fetchStoreTimeString } from "@/data/utils/storeUtil";
import { fetchSpecialStoreTimings, updateStoreDate } from "./clickAndCollect";

export const getStoreFeature = (store:StoreDetails, currentDay:number, storeEndTimeCutOff:string) => {
    let tempStoreFeture:StoreFeature = {} as StoreFeature;
    let hasSpecialTimes = false;
    let storeClosed = false;
    let storeStartTime, storeEndTime;
    let storeStartDate = new Date();
    let storeEndDate = new Date();
    const storeOpenTimeAttr = StoreOpenTimeAttrDayMapping[currentDay];
    let storeTimings = findStoreAttributeValueByName(store.attributes, storeOpenTimeAttr);
    let storeTImingsSpecial = fetchSpecialStoreTimings(store);
    if(storeTImingsSpecial && storeTImingsSpecial.includes("-") 
        && !storeTImingsSpecial?.toLowerCase().includes("gesloten")){
        storeTimings = storeTImingsSpecial;
        hasSpecialTimes = true;
        tempStoreFeture.storeTimingsSpecial = storeTImingsSpecial;
        tempStoreFeture.hasSpecialTimes=hasSpecialTimes;
    }else {
        storeTImingsSpecial = "";
    }

    if(storeTimings && storeTimings.includes("-")){
        storeStartTime = storeTimings.split("-")[0].trim().replace(":","");
        storeStartDate = updateStoreDate(storeStartTime, storeStartDate);
        storeEndTime = storeTimings.split("-")[1].trim().replace(":","");
        storeStartDate = updateStoreDate(storeEndTime, storeEndDate);
    }

    if(storeTimings.includes("gesloten")){
        storeClosed = true;
    }

    if (storeTImingsSpecial.includes("gesloten")){ 
        storeTImingsSpecial = "";
    }

    var currentDate = new Date();
    var localTimeForCurrentDate = currentDate.getTime();
    var localOffsetForCurrentDate = currentDate.getTimezoneOffset() * 60000;
    var utcForCurrentDate = localTimeForCurrentDate + localOffsetForCurrentDate;
    var offsetForCurrentDate = 2; // Have to change after day light savings
    var convertedTimeForCurrentDate = utcForCurrentDate + (3600000 * offsetForCurrentDate);
    var convertedDateTimeForCurrentDate = new Date(convertedTimeForCurrentDate); 
                    
    
    var sameDayDelivery = true;
    var deliveryDay = "";
    var storeOpenedToday = false;

    if(storeClosed){
        storeTimings = fetchStoreTimeString(currentDay+1, store, storeTImingsSpecial);
        //changeDeliveryMessage = true;
        sameDayDelivery = false;
        deliveryDay = storeTimings.split(" ")[0];
    }else if( (storeEndDate.getTime() > convertedDateTimeForCurrentDate.getTime()) 
            && ( (storeEndDate.getTime() - convertedDateTimeForCurrentDate.getTime()) <=  (parseInt(storeEndTimeCutOff) * 60000) ) ){
        storeTimings = fetchStoreTimeString(currentDay+1, store, storeTImingsSpecial);
        //changeDeliveryMessage = true;
        sameDayDelivery = false;
        deliveryDay = storeTimings.split(" ")[0];
    }else if ( (convertedDateTimeForCurrentDate.getTime() > storeEndDate.getTime()) ){
        storeTimings = fetchStoreTimeString(currentDay+1, store, storeTImingsSpecial);
        //changeDeliveryMessage = true;
        sameDayDelivery = false;
        deliveryDay = storeTimings.split(" ")[0];
    }else if( (storeStartDate.getTime() > convertedDateTimeForCurrentDate.getTime()) ){
        storeTimings = fetchStoreTimeString(currentDay, store, storeTImingsSpecial);
        //changeDeliveryMessage = true;
        sameDayDelivery = true;
    }else if( (storeStartDate.getTime() < convertedDateTimeForCurrentDate.getTime()) ){
        storeTimings = fetchStoreTimeString(currentDay, store, storeTImingsSpecial);
        //changeDeliveryMessage = false;
        sameDayDelivery = true;
    }
   
    tempStoreFeture.storeTimings = storeTimings;
    tempStoreFeture.storeClosed = storeClosed;
    tempStoreFeture.sameDayDelivery = sameDayDelivery;

    return tempStoreFeture;
}